import { c as _c } from "react/compiler-runtime";
import SplitTestActions from 'modules/funnels/funnel/components/split-tests-tab/split-test-actions';
import SplitTestHistory from 'modules/funnels/funnel/components/split-tests-tab/split-test-history';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import { useFunnelStepTests } from 'modules/funnels/funnel/hooks/use-funnel-step-tests';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
interface SplitTestsTabProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface;
}
function SplitTestsTab(t0) {
  const $ = _c(10);
  const {
    funnelId,
    funnelStep
  } = t0;
  const {
    splitTestData
  } = useFunnelStepTests(funnelStep.id);
  if (!splitTestData) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <TabContentLoader />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== funnelId || $[2] !== funnelStep || $[3] !== splitTestData) {
    t1 = <SplitTestActions funnelId={funnelId} funnelStep={funnelStep} data={splitTestData} />;
    $[1] = funnelId;
    $[2] = funnelStep;
    $[3] = splitTestData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== funnelStep) {
    t2 = <SplitTestHistory funnelStep={funnelStep} />;
    $[5] = funnelStep;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="desktop:gap-5 desktop:mb-0 mb-16 flex flex-col gap-4">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export default SplitTestsTab;